
export default function storeDateSelector () {
	return {
		restrict: 'E',
		scope: {
			state: '@',
			stores: '=',
			selectedStore: '=',
			endDate: '=',
			startDate: '='
		},
		bindToController: true,
		template: require('./store-date-selector.html'),
		transclude: true,
		controller: 'StoreDateSelectorController',
		controllerAs: 'storeDateSelector'
	}
};

storeDateSelector.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/store-date-selector/store-date-selector.js